/**
 * Custom hook for tab drag and drop handlers
 */

export const useTabDragHandlers = ({
  draggedTabId,
  setDraggedTabId,
  dragOverTabId,
  setDragOverTabId,
  tabs,
  setTabs,
  dispatch,
  updateTabOrder,
  urlIds,
  onTabClick,
}) => {
  const handleTabDrop = (e, targetTabId) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Only allow dropping for tabs with ID not equal to "0" and "1"
    if (targetTabId === "0" || targetTabId === "1" || !draggedTabId) {
      return;
    }

    if (draggedTabId === targetTabId) {
      setDraggedTabId(null);
      setDragOverTabId(null);
      return;
    }

    // Rearrange tabs
    setTabs(prevTabs => {
      const draggedTabIndex = prevTabs.findIndex(tab => tab.id === draggedTabId);
      const targetTabIndex = prevTabs.findIndex(tab => tab.id === targetTabId);
      
      if (draggedTabIndex === -1 || targetTabIndex === -1) {
        return prevTabs;
      }

      const newTabs = [...prevTabs];
      const [draggedTab] = newTabs.splice(draggedTabIndex, 1);
      
      // Insert the dragged tab at the target position
      newTabs.splice(targetTabIndex, 0, draggedTab);
      dispatch(updateTabOrder({
        matter_id: urlIds[0],
        document_id: draggedTabId.substring(1),
        new_position: targetTabIndex - 1
      }));
      return newTabs;
    });
    const draggedTab = tabs.find(tab => tab.id === draggedTabId);
    setDraggedTabId(null);
    setDragOverTabId(null);
    if (draggedTab) {
      onTabClick(draggedTab);
    }
  };

  const handleTabDragEnd = () => {
    setDraggedTabId(null);
    setDragOverTabId(null);
  };

  return {
    handleTabDrop,
    handleTabDragEnd,
  };
};
